import { blogData } from "./BlogData";
import { useState, useEffect } from 'react';
import BlogItem from './BlogItem';
import { base_url_url } from "../igtComponant/Links";
import AOS from 'aos';
import 'aos/dist/aos.css';
import {Helmet} from "react-helmet";

const Blog = () => {
    const [blogdata, setBlog] = useState([]);
    useEffect(() => {
        setBlog(blogData['blog']);

        AOS.init({ duration: 2000 });
    }, []);

    return (

        <>
            {/* <Helmet>
                <title>Blog | IGTechso </title>
                <link rel="canonical" href={`${process.env.PUBLIC_URL}/blog`}></link>
                <meta name="description" content="IGT" />
                <meta name="keywords" content="IGT" />
                <meta name="author" content="IGT" />
            </Helmet>
            <section className="blog-top">
                <div className="bg">
                    <img src={`${base_url_url}service-bottom-left.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" data-aos="fade-right" data-aos-once="true"  className="bottom-left" />
                    <img src={`${base_url_url}service-top-right.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" data-aos="fade-left" data-aos-once="true"  className="top-right" />
                </div>
                <div className="container">
                    <h2>Our Blog</h2>
                </div>
            </section>
            <section className="blogPage">
                <div className="blogGrid">
                    <div className="container">
                        <div className="blogLoop">
                            {
                                blogdata.map((data) =>
                                    <BlogItem id={data.id} title={data.title} body={data.excerpt} date={data.date} image={data.image} key={data.id} />
                                )
                            }
                        </div>
                    </div>
                </div>
            </section> */}

        </>
    )
}

export default Blog;